import React, { useState } from "react";
import ThreeDotsDropdown from "../common/ThreeDotsDropdown";
import styles from "../../_css/Home.module.css";
import { Star } from "lucide-react";
import DeleteReview from "../Modals/DeleteReview";
import AddReviewModal from "../Modals/AddReviewModal";
import { formatDate } from "../helper/formatters";
import { useDispatch } from "react-redux";
import { deleteReview, handleReview } from "../../requests";
import {
  deleteAuthToken,
  notifyError,
  notifySuccess,
} from "../../utils/helper";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { HOME_DATA_REVIEW_HISTORY } from "../../data/staticDataHome";
import { useSelector } from "react-redux";

function ReviewHistory({
  reviewData,
  reviewCount,
  onReviewChange,
  handleResumeSession,
}) {
  const [showDeleteReviewModal, setShowDeleteReviewModal] = useState(false);
  const [showAddReviewModal, setShowAddReviewModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  const dispatch = useDispatch();

  const lang = useSelector((state) => state.language.lang);
  const {
    reviewHistoryTitle,
    reviewHistorySubTitle,
    reviewHistoryItemDate,
    noRatings,
    btnText,
    reviewAddedSuccessfully,
    reviewUpdatedSuccessfully,

  } = HOME_DATA_REVIEW_HISTORY[lang];

  const handleAddReview = async (review, ratings) => {
    setShowAddReviewModal(false);
    dispatch(startLoader());
    try {
      const response = await handleReview({
        review: review,
        ratings: ratings,
        review_id: selectedReview?.review_id,
        user_session_id: selectedReview?.user_session_id,
      });
      if (response.status === 200) {
       if(response?.data?.message == "Review updated successfully") {
        notifySuccess(reviewUpdatedSuccessfully);
       }else{
        notifySuccess(reviewAddedSuccessfully);
       }
        // notifySuccess(response.data.message);
        onReviewChange();
      }
      // Set pagination data from API response
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      // notifyError(error?.response?.data?.message);
      notifyError(lang === "ar" ? "فشل إضافة التقييم" : error?.response?.data?.message);
      console.error("Error in sending message:", error);
    }
    setSelectedReview(null);
    dispatch(stopLoader());
  };

  const handleDeleteReview = async (review) => {
    setShowDeleteReviewModal(false);
    dispatch(startLoader());
    try {
      const response = await deleteReview({
        review_id: review?.review_id,
      });
      if (response.status === 200) {
        notifySuccess(response.data.message);
        onReviewChange();
      }
      // Set pagination data from API response
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      notifyError(error?.response?.data?.message);
      console.error("Error in sending message:", error);
    }
    setSelectedReview(null);
    dispatch(stopLoader());
  };

  return (
    <div className={styles.reviewHistory}>
      <DeleteReview
        show={showDeleteReviewModal}
        onHide={() => setShowDeleteReviewModal(false)}
        onRemoveReview={() => handleDeleteReview(selectedReview)}
        givenReviewId={selectedReview?.review_id}
      />
      <AddReviewModal
        show={showAddReviewModal}
        onHide={() => setShowAddReviewModal(false)}
        onSubmit={handleAddReview}
        reviewData={selectedReview}
        btnText={btnText}
      />
      <div className={styles.reviewHistoryHeader}>
        <h4>{reviewHistoryTitle}</h4>
        <p>{reviewHistorySubTitle.replace("{reviewCount}", reviewCount)}</p>
      </div>
      {reviewData.map((review, index) => (
        <div
          key={index}
          className={
            styles.reviewHistoryItem + " " + styles[`border${index + 1}`]
          }
          onClick={() => {
            sessionStorage.setItem("userSessionId", review?.user_session_id);
            handleResumeSession(true);
          }}
        >
          <p className={styles.reviewHistoryItemDate}>
            <span>{reviewHistoryItemDate}</span>
            <strong>{formatDate(review.session_created_at)}</strong>
          </p>
          <div className={styles.reviewHistoryItemActions}>
            <div className={styles.reviewHistoryItemActionsItem}>
              <div
                className={
                  styles[`fillWith${review?.ratings}`] + " " + styles.fillWith
                }
              >
                <span
                  key={index}
                  style={{ width: 16, height: 16, padding: "3px" }}
                  className={`star ${styles[`filled${review?.ratings}`]}`}
                >
                  <Star fill="white" stroke="white" />
                </span>
                {review?.ratings ? (
                  <span className={styles.fillWithText}>
                    {review?.ratings}/5
                  </span>
                ) : (
                  <span className={styles.fillWithText}>{noRatings}</span>
                )}
              </div>
              {![1, 9].includes(review?.status) && (
                <ThreeDotsDropdown
                  onEdit={(e) => {
                    e.stopPropagation();
                    setShowAddReviewModal(true);
                    setSelectedReview(review);
                  }}
                  onDelete={(e) => {
                    e.stopPropagation();
                    setShowDeleteReviewModal(true);
                    setSelectedReview(review);
                  }}
                  isEdit={review?.review_id ? true : false}
                />
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ReviewHistory;
